import React, { Component } from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import { Navigation, NavigationItem, Sidebar, Logo, Theme, NavigationSeparator } from '@spoiler-alert/ui-library';
import { inject, observer } from 'mobx-react';
import { withRouter } from 'react-router-dom';
import routePaths from '../../route-paths';
import Actions from './actions';
import AppSettings from '../../app-settings';

const styles = {
  sa__logo: {
    display: 'flex',
    justifyContent: 'flex-start',
    width: 152,
    height: 33,
    margin: '29px 0 35px 24px',
    padding: 0,
  },
  sa__img: {
    width: 152,
    height: 33,
  },
  '@media (max-width: 840px)': {
    sa__logo: {
      display: 'none',
    },
  },
};

@injectSheet(styles)
@withRouter
@inject('rootStore')
@observer
export default class SidebarWrapper extends Component {
  mounted = true;

  componentWillUnmount() {
    this.mounted = false;
  }

  close = () => {};

  render() {
    const { classes, onClose, onOpen, rootStore } = this.props;

    return (
      <Sidebar
        collapsed={rootStore.sidebarStatus.collapsed}
        onClose={onClose}
        onOpen={onOpen}
        backgroundColor={
          (AppSettings.ENVIRONMENT_NAME === 'staging' && Theme.teal30) ||
          undefined ||
          (AppSettings.ENVIRONMENT_NAME === 'uat' && Theme.yellow30) ||
          undefined
        }
      >
        <Logo route="/" className={classes.sa__logo} imageClassName={classes.sa__img} />
        <Navigation>
          <NavigationItem
            defaultText="Dashboards"
            id="dashboard"
            i18nKey="dashboard"
            route={routePaths.home}
            icon="dashboard"
            onClick={this.close}
          />
          <NavigationSeparator key={'customer-admin'}>Customer Admin</NavigationSeparator>
          <NavigationItem
            defaultText="Site Administration"
            id="sites"
            i18nKey="sites"
            route={routePaths.sites}
            icon="building"
            onClick={this.close}
          />
          <NavigationItem
            defaultText="BSR Editor"
            id="edit-site"
            i18nKey="edit"
            route={routePaths.editBSR}
            icon="wand"
            onClick={this.close}
          />
          <NavigationItem
            defaultText="User Session Manager"
            id="user-session-manager"
            i18nKey="user-session-manager"
            route={routePaths.userSessionManager}
            icon="user"
            onClick={this.close}
          />
          <NavigationItem
            defaultText="Buyer X Access"
            id="buyer-x-access"
            i18nKey="buyer-x-access"
            route={routePaths.buyerPortalAccess}
            icon="user"
            onClick={this.close}
          />
          <NavigationSeparator key={'config-mgmt'}>Configuration Managers</NavigationSeparator>
          <NavigationItem
            defaultText="Import Manager"
            id="import-manager"
            i18nKey="import-manager"
            route={routePaths.importManager}
            icon="importmanager"
            onClick={this.close}
          />
          <NavigationItem
            defaultText="Export Manager"
            id="export-manager"
            i18nKey="export-manager"
            route={routePaths.exportManager}
            icon="exportmanager"
            onClick={this.close}
          />
          <NavigationItem
            defaultText="Data Table Manager"
            id="data-table-manager"
            i18nKey="data-table-manager"
            route={routePaths.dataTableManager}
            icon="datatablemanager"
            onClick={this.close}
          />
          <NavigationItem
            defaultText="Custom Filters"
            id="customFilters"
            i18nKey="customFilters"
            route={routePaths.customFilters}
            icon="filter"
            onClick={this.close}
          />
          <NavigationItem
            defaultText="Feature Manager"
            id="featureFlags"
            i18nKey="featureFlags"
            route={routePaths.featureFlagManager}
            icon="cloudupload"
            onClick={this.close}
          />
          <NavigationItem
            defaultText="Billing Manager"
            id="billing-manager"
            i18nKey="billing-manager"
            route={routePaths.billingManager}
            icon="calculator"
            onClick={this.close}
          />
          <NavigationSeparator key={'data-mgmt'}>Data Managers</NavigationSeparator>
          <NavigationItem
            defaultText="Inventory Manager"
            id="inventory-manager"
            i18nKey="inventory-manager"
            route={routePaths.inventoryManager}
            icon="historydetail"
            onClick={this.close}
          />
          <NavigationItem
            defaultText="Data Approval Mgr"
            id="data-approval-manager"
            i18nKey="data-approval-manager"
            route={routePaths.approvalManager}
            icon="building"
            onClick={this.close}
          />
          <NavigationItem
            defaultText="Offer Manager"
            id="offer-manager"
            i18nKey="offer-manager"
            route={routePaths.offerManager}
            icon="acceptoffers"
            onClick={this.close}
          />
          <NavigationItem
            defaultText="Data"
            id="data"
            i18nKey="data"
            route={routePaths.data}
            icon="boxhandle"
            onClick={this.close}
          />
          <NavigationItem
            defaultText="Category Manager"
            id="category-manager"
            i18nKey="category-manager"
            route={routePaths.categoryManager}
            icon="items"
            onClick={this.close}
          />
          <NavigationItem
            defaultText="Prompt Manager"
            id="prompt-manager"
            i18nKey="prompt-manager"
            route={routePaths.promptManager}
            icon="pencil"
            onClick={this.close}
          />
          <NavigationItem
            defaultText="Exports"
            id="exports"
            i18nKey="exports"
            route={routePaths.exports}
            icon="export"
            onClick={this.close}
          />
          <NavigationItem
            defaultText="Timebomb Mgr"
            id="timebomb-manager"
            i18nKey="timebomb-manager"
            route={routePaths.timeBombManager}
            icon="history"
            onClick={this.close}
          />
          <NavigationItem
            defaultText="Negotiation Manager"
            id="negotiation-manager"
            i18nKey="negotiation-manager"
            route={routePaths.negotiationManager}
            icon="historydetail"
            onClick={this.close}
          />
          <NavigationItem
            defaultText="Hello Fresh Edits"
            id="hello-fresh"
            i18nKey="hello-fresh"
            route={routePaths.helloFresh}
            icon="flag"
            onClick={this.close}
          />
          <NavigationSeparator key={'network-listing'}>Network Listing</NavigationSeparator>
          <NavigationItem
            defaultText="Curated DLs"
            id="curated-dls"
            i18nKey="curated-dls"
            route={routePaths.curatedNetworkListing}
            icon="content"
            onClick={this.close}
          />
          <NavigationItem
            defaultText="Buyer Manager"
            id="buyer-manager"
            i18nKey="buyer-manager"
            route={routePaths.buyerManager}
            icon="box"
            onClick={this.close}
          />
          <NavigationItem
            defaultText="PO Manager"
            id="po-manager"
            i18nKey="po-manager"
            route={routePaths.purchaseOrderManager}
            icon="receipt"
            onClick={this.close}
          />
          <NavigationItem
            defaultText="NUMOCO Orders"
            id="numoco-orders"
            i18nKey="numoco-orders"
            route={routePaths.numocoOrderManager}
            icon="adjustsuggestedprice"
            onClick={this.close}
          />
          <NavigationSeparator key={'marketplace'}>Marketplace</NavigationSeparator>
          <NavigationItem
            defaultText="Marketplace Mgr"
            id="marketplace-manager"
            i18nKey="marketplace-manager"
            route={routePaths.marketplaceManager}
            icon="building"
            onClick={this.close}
          />
        </Navigation>

        <Actions>{this.props.children}</Actions>
      </Sidebar>
    );
  }
}

SidebarWrapper.propTypes = {
  user: PropTypes.object,
  classes: PropTypes.object,
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onOpen: PropTypes.func,
  history: PropTypes.object,
  rootStore: PropTypes.object,
  children: PropTypes.node,
};
